import { render, staticRenderFns } from "./Vinput.vue?vue&type=template&id=36718e44"
import script from "./Vinput.vue?vue&type=script&lang=js"
export * from "./Vinput.vue?vue&type=script&lang=js"
import style0 from "./Vinput.vue?vue&type=style&index=0&id=36718e44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports